"use client";
import { Avatar, Text } from "@/elements"
import clsx from "clsx"
import Link from "next/link"
import { usePathname } from "next/navigation"
import { useSidebar } from "../Sidebar/useSidebar"
import { MessagesBadge } from "./MessagesBadge"
import { NavItemWrapper } from "./NavItemWrapper"
import { NovaAccount } from "@/types"

import type { JSX } from "react";

interface Props {
  solidIcon?: () => JSX.Element | null
  outlineIcon?: () => JSX.Element | null
  title: string
  href: string
  iconProps?: React.SVGProps<SVGSVGElement>
  forceHideLabel: boolean
  size: "default" | "lg"
  accountType: NovaAccount
}

export const VerticalNavItem: React.FC<Props> = ({
  solidIcon,
  outlineIcon,
  title,
  href,
  forceHideLabel = false,
  size,
  accountType,
}) => {
  const pathname = usePathname()
  const { secondaryBar } = useSidebar()
  const isLarge = size === "lg"
  const viewerIsClient = accountType === "client"

  let isActive = false
  if (secondaryBar.open) {
    isActive = false
  } else if (pathname === href) {
    isActive = true
  } else if (pathname?.startsWith(href + "/")) {
    isActive = true
  } else if (href === "/" && pathname?.startsWith("/hire") && viewerIsClient) {
    isActive = true
  } else if (href === "/jobs" && pathname === "/" && !viewerIsClient) {
    isActive = true
  }

  return (
    <Link key={title} href={href} prefetch>
      <NavItemWrapper>
        <div className="relative">
          {href === "/messages" && <MessagesBadge />}
          {href === "/profile" ? <Avatar size="2xs" /> : isActive ? solidIcon?.() : outlineIcon?.()}
        </div>
        <div className="absolute left-[44px] transition-opacity duration-200 ease-in-out md:opacity-0 lg:opacity-100">
          <Text
            variant={isLarge ? "h4" : "body1"}
            className={clsx(
              "w-[117px] flex-shrink-0 select-none md:hidden lg:flex",
              forceHideLabel && "!hidden",
              isActive ? "text-fg-1" : "text-fg-3"
            )}>
            {title}
          </Text>
        </div>
      </NavItemWrapper>
    </Link>
  )
}
